import PersonalInfoConfirmation from './PersonalInfoConfirmation';

export default PersonalInfoConfirmation;